export function getFormattedDate(miliseconds: number) {
    const createdAt = new Date(miliseconds);
    const now = new Date();

    let diffMinutes = Math.round(Math.abs(createdAt.getTime() - now.getTime()) / 1000 / 60);
    const diffHours = Math.round(diffMinutes / 60);
    const diffDays =  Math.floor(diffHours / 24);
    const diffWeeks =  Math.floor(diffDays / 7);
    const diffMonths =  Math.floor(diffDays / 30);
    const diffYears =  Math.floor(diffMonths / 12);

    if (diffYears >= 1) {
        return printFormattedDate(diffYears, 'year');
    }
    if (diffMonths >= 1) {
        return printFormattedDate(diffMonths, 'month');
    }
    if (diffWeeks >= 1) {
        return printFormattedDate(diffWeeks, 'week');
    }
    if (diffDays >= 1) {
        return printFormattedDate(diffDays, 'day');
    }
    if (diffHours >= 1) {
        return printFormattedDate(diffHours, 'hour');
    }

    if (diffMinutes < 1) {
        diffMinutes = 1;
    }

    return printFormattedDate(diffMinutes, 'minute');
}

function printFormattedDate(count: number, name: string) {
    name = count > 1
        ? name + 's'
        : name;
    
    return `${count} ${name} ago`;
}

export function escapeHtml(unsafe: string): string {
    return unsafe
         .replace(/&/g, '&amp;')
         .replace(/</g, '&lt;')
         .replace(/>/g, '&gt;')
         .replace(/"/g, '&quot;')
         .replace(/'/g, '&#039;');
 }